/* eslint-disable indent */
import getParameterFromURL from '../utils/scripts/getParameterFromURL';

const initialState = {
	showLoader: false,
	pauseLoader: getParameterFromURL('question_on_loader') === 'true' || getParameterFromURL('config') === 'long' || true,
	showSteps: true,
	showResultPage: false,
	menuOpened: false,
	initialGender: getParameterFromURL('gender') || 'female',
	ageStepScreen: getParameterFromURL('ageStepScreen') || 'a',
	xmasConfig: getParameterFromURL('config') === 'xmas_long' || getParameterFromURL('config') === 'xmas_short',
	theme: getParameterFromURL('theme'),
	resultPage0day: getParameterFromURL('resultPage0day') === 'true',
	resultPagePersonolizedPlan: getParameterFromURL('resultPagePersonolizedPlan') === 'true',
	resultPagePlansTable: getParameterFromURL('resultPagePlansTable') === 'true',
	promocode: null,
	forceLang: getParameterFromURL('force_lang'),
	planMan: getParameterFromURL('planMan') === 'true',
};

function steps(state = initialState, action) {
	switch (action.type) {
		case 'TOGGLE_LOADER':
			return {
				...state,
				showLoader: action.payload,
			};

		case 'TOGGLE_PAUSE_LOADER':
			return {
				...state,
				pauseLoader: action.payload,
			};

		case 'TOGGLE_RESULT_PAGE':
			return {
				...state,
				showResultPage: action.payload,
			};

		case 'TOGGLE_STEPS':
			return {
				...state,
				showSteps: action.payload,
			};

		case 'TOGGLE_MENU':
			return {
				...state,
				menuOpened: action.payload,
			};

		case 'SET_PROMOCODE':
			return {
				...state,
				promocode: action.payload,
			};

		default:
			return state;
	}
}

export default steps;
